import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import Assessment from '@material-ui/icons/Assessment'
import TextField from "@material-ui/core/TextField";
import {Objects} from "../index";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import GradeComponent from "../Objects/GradeComponent";
import Collections from "./index";

export default class Hiring_Scores extends Framework.Components.Collection {
	constructor(props) {

		let model = new API.BuildClass(Types.Hiring_Scores._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = this.props.user ? this.props.week_view ? 'GET_WEEKLY' : 'GET_ALL' : 'GET_DAILY';
		this.state.limit = 50;
		//this.state.filterDate = moment(Date.now()).format();
		this.state.filterDate = moment(this.props.filterDate ?? Date.now()).format('YYYY-MM-DD');
		this.state.showDate = false;
	}

	fetchData = async () => {
		this.state.limit = 50;
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.filterDate = moment(this.state.filterDate).format('YYYY-MM-DD');
		this.state.filter.user = this.props.user ?? null;
		this.state.filter.week_view = this.props.week_view;
		this.model.filter = this.state.filter;
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual();
		}, 100);
	}

	formatData = async (res) => {
		if (!this.props.user || (this.props.user && this.props.week_view)) {
			return res;
		}

		let rows = [];
		let gap = 1;
		await Promise.all(res.rows.map((row, index) => {
			rows.push(row);
			const {created, user, users, ...rest} = row;
			if (res.rows[index + 1]) {
				// fill gaps until next entry
				while (moment(row.created).add(gap, 'hours').format('h A') !== moment(res.rows[index + 1].created).format('h A')) {
					let blank = {created: moment(row.created).add(gap, 'hours').format(), user: row.user, users};
					Object.keys(rest).forEach((key) => blank[key] = 0);
					rows.push(blank);
					gap++;
				}
				gap = 1;
			} else {
				// fill out to 8 slots
				while (rows.length < 8) {
					let blank = {created: moment(row.created).add(gap, 'hours').format(), user: row.user, users};
					Object.keys(rest).forEach((key) => blank[key] = 0);
					rows.push(blank);
					gap++;
				}
			}
		}));
		res.rows = rows;
		return res;
	};

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	handleDateChange = async (name, date) => {
		this.state.filterDate = moment(date).format();
		await this.setState({filterDate: moment(date).format('YYYY-MM-DD')});
		this.handleToggleModal('showDate');
		await this.fetchData();
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns = [
			{
				Header: "Heatmap",
				id: 'heatmap',
				/** @param {Hiring_Scores_Object} obj */
				accessor: obj => obj.heatmap,
			},
			{
				Header: "New Candidate",
				id: 'new_candidate',
				/** @param {Hiring_Scores_Object} obj */
				accessor: obj => obj.new_candidate,
			},
			{
				Header: "Promotion",
				id: 'promotion',
				/** @param {Hiring_Scores_Object} obj */
				accessor: obj => obj.promotion,
			},
			{
				Header: "Demotion",
				id: 'demotion',
				/** @param {Hiring_Scores_Object} obj */
				accessor: obj => obj.demotion,
			},
			{
				Header: "Notes Length",
				id: 'notes_length',
				/** @param {Hiring_Scores_Object} obj */
				accessor: obj => obj.notes_length,
			},
			{
				Header: "Project Notes Length",
				id: 'project_notes',
				/** @param {Hiring_Scores_Object} obj */
				accessor: obj => obj.project_notes,
			},
			{
				Header: "Total Score",
				id: 'total_score',
				/** @param {Hiring_Scores_Object} obj */
				accessor: obj => obj.total_score,
			},
			{
				Header: 'Grade',
				id: "letter_score_day",
				className: "button-cell",
				filterable: false,
				sortable: true,
				width: 200,
				accessor: obj => obj.letter_score_day,
				Cell: props => {
					return (
						<>
							{(props.original.letter_score_day || props.original.total_score) ?
								<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
									<GradeComponent score={props.original.letter_score_day ?? props.original.total_score}
									                type={'helpdesk'}/>
									&nbsp;
									{!this.props.user &&

										<Button color="blue-hoki" size={"sm"} block={false} onClick={() => {
											this.setState({
												user: props.original.user,
												hourly_breakdown_modal: true,
												name: props.original.users.name_first + " " + props.original.users.name_last,
												day_score_display: props.original.letter_score_day,
												day_score: props.original.letter_score_day
											})
										}}>
											<Assessment fontSize={'small'}/></Button>}
								</div> :
								<b>
									N/A
								</b>}
						</>
					);
				}
			},
		]

		if (!this.props.user) {
			columns = [{
				Header: "User",
				id: 'user',
				/** @param {Hiring_Scores_Object} obj */
				accessor: obj => obj.users?.name_first + ' ' + obj.users?.name_last,
			}, ...columns];
		} else {
			columns = [{
				Header: this.props.week_view ? 'Day' : "Hour",
				id: 'created',
				/** @param {Hiring_Scores_Object} obj */
				accessor: obj => this.props.week_view ? moment(obj.created).format("MM/DD") : moment(obj.created).format('h A'),
			}, ...columns];
		}
		const regexp = new RegExp(/\D/, 'g');
		return (
			<div className={'container-fluid'}>
				{this.props.week_view && !this.props.user && <b>Values shown are averages/day</b>}
				<Card>
					<CardContent>
						<div className="table-bar">
							<Modal
								isOpen={this.state.showDate}
								toggle={() => this.handleToggleModal('showDate')}
								size={"sm"}
								backdrop={true}
								style={{display: "none"}}
							>
								<ModalBody>
									<Framework.Elements.Date
										label={"Custom Date"}
										value={this.state.filterDate}
										update={this.handleDateChange}
										open={this.state.showDate}
										clearable={false}
										cancelLabel={''}
									/>
								</ModalBody>
							</Modal>
							{!this.props.hideDates && <div className={"row rbc-toolbar"}>
								<div>
									<IconButton onClick={async () => {
										const date = moment(this.state.filterDate).subtract(1, this.props.week_view ? 'week' : 'day').format("YYYY-MM-DD");
										this.setState({
											filterDate: date,
										}, async () => {
											if (typeof(this.props.changeFilterDate) === 'function') {
											await this.props.changeFilterDate(date);
										}
											await this.fetchData()
										})
									}}><LeftArrowIcon/></IconButton>
									<button className="rbc-today" type="button" onClick={async () => {
										const today = moment(Date.now()).format('YYYY-MM-DD');
										this.setState({
											filterDate: today,
										}, async () => {
											if (typeof(this.props.changeFilterDate) === 'function') {
											await this.props.changeFilterDate(date);
										}
											await this.fetchData()
										})
									}}>Today
									</button>
									<IconButton disabled={moment(this.state.filterDate).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')} onClick={async () => {
										const date = moment(this.state.filterDate).add(1, this.props.week_view ? 'week' : 'day').format("YYYY-MM-DD");
										this.setState({
											filterDate: date,
										}, async () => {
											if (typeof(this.props.changeFilterDate) === 'function') {
											await this.props.changeFilterDate(date);
										}
											await this.fetchData()
										})
									}}><RightArrowIcon/></IconButton>
								</div>
								<div className={"rbc-toolbar-label"}>
									<label>
										{this.props.week_view ? (moment(this.state.filterDate).day(0).format('dddd MMM D') + ' - ' + moment(this.state.filterDate).day(0).add(6, 'days').format('dddd MMM D')) : moment(this.state.filterDate).format('dddd MMM D')}
									</label>
								</div>
								{!this.props.user && <div className="d-flex">
									{this.renderHeaderRight("KPI Scores Hiring",columns)}
								</div>}
							</div>}
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							onSortedChange={this.onSortedChange}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							defaultPageSize={data.length}
							className="-striped -highlight"
							onPageSizeChange={this.onPageSizeChange}
							pageSize={data.length}
						/>

						<Framework.Elements.LoadingSpinner isLoading={loading}/>
					</CardContent>
				</Card>
				<Framework.Elements.UniversalModal
					size={"xl"}
					name={`Hourly Breakdown for ${this.state.name} on ${moment(this.state.filterDate).format('dddd, MMMM Do')}`}
					object={Collections.HiringScores}
					history={this.props.history}
					toggle={this.state.hourly_breakdown_modal}
					reportClose={() => this.handleToggleModal('hourly_breakdown_modal')}
					objectProps={{
						user: this.state.user,
						filterDate: this.state.filterDate,
						name: this.state.name,
						day_score_display: this.state.day_score_display,
						day_score: this.state.day_score,
						hideDates: true,
						week_view: this.props.week_view
					}}
					hideGoTo={true}
					hasSubmit={false}
				/>
			</div>
		)
	}
}
